module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/user-black.15a8d912.svg";